import {
  FI_DATA,
  FI_DATA_LOADING,
  FI_AVG_FE,
  FI_STATS,
  INSIGHTS_LOADING,
  INSIGHTS_SUCCESS,
  INSIGHTS_STREAMING,
  INSIGHTS_PROGRESS,
  INSIGHTS_ERROR,
  INSIGHTS_CLEAN,
  INSIGHTS_CARD_TOGGLE,
  INSIGHTS_CARDS_RESTORE,
} from './InsightsActions';

const INITIAL_STATE = {
  error: '',
  isLoading: true,
  loaded: false,
  insights: null,
  metrics: {},
  cfd: [],
  cfdLoading: true,
  cth: {},
  cthLoading: true,
  cta: [],
  ctaLoading: true,
  fe: {},
  feLoading: true,
  isStreaming: false,
  cards: {},
  retry: false,
  progress: ''
};

const InsightsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FI_DATA_LOADING: {
      return {
        ...state,
        cfdLoading: true,
        cthLoading: true,
        ctaLoading: true,
        feLoading: true
      };
    }
    case FI_DATA: {
      return {
        ...state,
        [action.chart]: action.data,
        [`${action.chart}Loading`]: false,
      };
    }
    case FI_AVG_FE: {
      return {
        ...state,
        fe: action.data,
        feLoading: false,
      };
    }
    case FI_STATS: {
      return {
        ...state,
        metrics: action.data
      };
    }  
    case INSIGHTS_CLEAN: {
      return { ...state, isLoading: true, loaded: false, insights: null, retry: false, error: '', progress: '' };
    }
    case INSIGHTS_LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case INSIGHTS_SUCCESS: {
      return { ...state, insights: action.data, loaded: true, retry: false, error: '' };
    }
    case INSIGHTS_ERROR: {
      return { ...state, retry: action.retry, error: action.error };
    }
    case INSIGHTS_STREAMING: {
      return { ...state, isStreaming: action.isStreaming };
    }
    case INSIGHTS_PROGRESS: {
      return { ...state, progress: action.progress };
    }
    case INSIGHTS_CARD_TOGGLE: {
      return { ...state, cards: { ...state.cards, [action.id]: !state.cards[action.id] } };
    }
    case INSIGHTS_CARDS_RESTORE: {
      return { ...state, cards: action.cards };
    }
    default:
      return state;
  }
};

export default InsightsReducer;
